import { Route, Routes } from 'react-router-dom'
import { ClientsPage } from 'pages/clients/ui/clientsPage'
import { ClientsAccessLayout } from 'pages/clients/layout/ClientsAccessLayout'
import { ClientsPageLayout } from 'pages/clients/layout/ClientsPageLayout'
import { CreateRouter } from 'pages/clients/pages/create/route/createRouter'
import { ClientsRoutes } from './type'

export const ClientsRouter = () => {
  return (
    <Routes>
      <Route element={<ClientsAccessLayout />}>
        <Route element={<ClientsPageLayout />}>
          <Route path={'/'} element={<ClientsPage />} />
        </Route>
        <Route path={`${ClientsRoutes.create}`} element={<CreateRouter />} />
      </Route>
    </Routes>
  )
}
